import { call } from '@/lib/api';
import { ActionIcon, rem, Stack, Table, Text, Tooltip } from '@mantine/core';
import { PiDownload, PiFile } from 'react-icons/pi';
import { KYCInfo } from './types';
import { Document } from '@/types';

export default function KYCDocuments({
  kycInfo,
  documents,
}: {
  kycInfo: KYCInfo;
  documents: Document[] | null;
}) {
  if (!kycInfo.applicantId) {
    return (
      <Stack>
        <Text size="md" fw={700} tt="capitalize">
          SumSub Documents
        </Text>
        <Text size="sm">
          The KYC process have not been completed, therefore there's no
          documents yet.
        </Text>
      </Stack>
    );
  }

  if (!documents || documents.length === 0) {
    return (
      <Stack>
        <Text size="md" fw={700} tt="capitalize">
          SumSub Documents
        </Text>
        <Text size="sm">
          No documents were gathered from SumSumb. This is unusual. Please
          contact support at{' '}
          <a href="mailto:it-support@legalbison.atlassian.net">
            it-support@legalbison.atlassian.net
          </a>
        </Text>
      </Stack>
    );
  }

  return (
    <Stack>
      <Text size="md" fw={700} tt="capitalize">
        SumSub Documents
      </Text>
      <Table highlightOnHover striped>
        <Table.Tbody>
          {documents.map((d, i) => (
            <Table.Tr key={i}>
              <Table.Td w="1">
                <PiFile />
              </Table.Td>
              <Table.Td w="auto">{d.name}</Table.Td>
              <Table.Td w="1">
                <Tooltip label="Download" withArrow position="top">
                  <ActionIcon
                    variant="subtle"
                    onClick={() => {
                      call<void>('document/download', {
                        json: {
                          id: d.id,
                        },
                      })
                        .then((res) => res.blob())
                        .then((bytes) => {
                          const href = URL.createObjectURL(bytes);
                          const link = document.createElement('a');
                          link.href = href;
                          link.setAttribute('download', d.filename);
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                          URL.revokeObjectURL(href);
                        });
                    }}
                  >
                    <PiDownload style={{ width: rem(16) }} />
                  </ActionIcon>
                </Tooltip>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Stack>
  );
}
